import React from "react";
import styles from "./Padding.module.css";
import Tooltip from "../../../../../components/common/Tooltip/Tooltip";
import {
  PaddingTopIcon,
  PaddingRightIcon,
  PaddingBottomIcon,
  PaddingLeftIcon,
} from "../../../../../icons";

const directionIcons = {
  top: <PaddingTopIcon className={styles.icon} />,
  right: <PaddingRightIcon className={styles.icon} />,
  bottom: <PaddingBottomIcon className={styles.icon} />,
  left: <PaddingLeftIcon className={styles.icon} />,
};

const PaddingPill = ({ value, onChange, direction }) => {
  const handleChange = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    if (val === "") {
      onChange(0);
    } else {
      const numeric = Math.min(90, Math.max(0, Number(val)));
      onChange(numeric);
    }
  };

  const tooltipText = {
  top: "Top padding\nPushes image downward",
  right: "Right padding\nPushes image left",
  bottom: "Bottom padding\nPushes image upward",
  left: "Left padding\nPushes image right"
};

  return (
    <div className={styles.pill}>
      <Tooltip content={tooltipText[direction]} position="top">
        <div className={styles.iconWrapper}>
         {directionIcons[direction]}
        </div>
     </Tooltip>

      <input
        type="text"
        inputMode="numeric"
        value={value}
        onChange={handleChange}
        className={styles.input}
      />

      <span className={styles.percent}>%</span>
    </div>
  );
};

export default PaddingPill;